export default __webpack_public_path__ + "static/media/phonemobile.3ba29d74.svg";